import React, { useEffect } from 'react';
import { connect } from "react-redux";
import * as actions from "../../Actions/comments";
import PropTypes from 'prop-types';
import cssClasses from './Comments.css';
import CommentsList from './CommentsList';
import CommentEdit from './CommentEdit';
import ModalsHeader from '../Modals/ModalsHeader';

const CommentModal = (props) => {
    useEffect(() => {
        props.getComments(localStorage.getItem("bookid"), props.transactionId);
    }, []);

    const handleSaveComment = (values) => {
        props.postComment(values, localStorage.getItem("bookid"), props.transactionsList[props.transactionId]);
    }

    const handleDeleteComment = (commentId) => {
        props.deleteComment(commentId, props.transactionsList[props.transactionId], localStorage.getItem("bookid"), props.comments);
    }

    return (
        <div className={cssClasses.comments_modal}>
            <ModalsHeader title="Comments" closeModal={props.closeModal}/>
            {props.comments.length > 0 && <CommentsList handleDeleteComment={handleDeleteComment} comments={props.comments} />}
            <CommentEdit onSubmit={handleSaveComment} status={props.status} />
        </div>
    )
}

CommentModal.propTypes = {
    transactionId: PropTypes.string.isRequired,
    comments: PropTypes.array.isRequired,
    postComment: PropTypes.func.isRequired,
    getComments: PropTypes.func.isRequired,
    deleteComment: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        comments: state.comments,
        status: state.status,
        transactionsList: state.transactions.transactionsList
    };
}
export default connect(mapStateToProps, actions)(CommentModal);


// WEBPACK FOOTER //
// ./src/components/Comments/CommentModal.js